import ResPickpuDropoffLabel from "@components/ResPickupDropoffLabel";
import { formatWithLocale } from "@hudson/ui/lib/date_fns_locale";
import Session from "@lib/session";
import classNames from "classnames";
import dynamic from "next/dynamic";
import useContent from "@lib/use_content";
import { useColorsQuery } from "@graphql/api";

function TripHead({
  className,
  dateClassName,
  locsClassName,
  noDate = false,
  noLocations = false,
  legNum = Session.isSecondLeg() ? 1 : 0,
}: {
  className?: string;
  dateClassName?: string;
  locsClassName?: string;
  legNum?: number;
  noDate?: boolean;
  noLocations?: boolean;
}): JSX.Element | null {
  const {
    data: cData,
    loading: cLoading,
    error: cError,
  } = useContent(["beFirstLegHeader", "beReturnTripHeader"]);
  const { data, loading, error } = useColorsQuery();

  if (error || cError) {
    console.error(error, cError);
    return null;
  }

  let title;
  const isRoundtrip = Session.getBooking().roundtrip;
  if (legNum == 1) {
    title = cData?.content.beReturnTripHeader;
  } else if (isRoundtrip) {
    title = cData?.content.beFirstLegHeader;
  }

  const res = Session.getLeg(legNum);

  if (title) {
    return (
      <div
        className={`${
          className ? className : ""
        } flex flex-wrap gap-x-3 items-end font-title tracking-tight`}
      >
        <h2>
          {noLocations ? (
            <span className={classNames(locsClassName, "block")}>{title}</span>
          ) : (
            loading || (
              <div
                className={classNames(
                  locsClassName,
                  "flex items-center font-bold flex-wrap opacity-70",
                )}
                style={{ color: data?.colors.primaryColor }}
              >
                {res?.pickup && res?.dropoff && (
                  <ResPickpuDropoffLabel pickup={res?.pickup} dropoff={res?.dropoff} />
                )}
              </div>
            )
          )}
        </h2>

        {res?.service?.selectedTime?.pickupTime && !noDate && (
          <div
            className={classNames(
              dateClassName,
              "tracking-tight -mt-1 text-gray-600 font-extralight",
            )}
          >
            {formatWithLocale(res?.service?.selectedTime?.pickupTime, "EEEE MMMM do")}
          </div>
        )}
      </div>
    );
  }
  return null;
}

export default dynamic(() => Promise.resolve(TripHead), {
  ssr: false,
});
